import Vue from 'vue'
import VueMeta from 'vue-meta'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import i18n from '@/libs/i18n'
// eslint-disable-next-line import/no-extraneous-dependencies, no-unused-vars
import Swal from 'sweetalert2'
import router from './vue.router'
import store from './store'
import App from './App.vue'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueMeta)

// Composition API
Vue.use(VueCompositionAPI)
// Global Components
Vue.component(FeatherIcon.name, FeatherIcon)

// import core styles
require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

// applicationinsights-web
if (process.env.VUE_APP_APPINSIGHTS_CONNECTION_STRING) {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: process.env.VUE_APP_APPINSIGHTS_CONNECTION_STRING,
      autoTrackPageVisitTime: true,
      enableAutoRouteTracking: true, // enable automatic route change tracking for your single page application
    },
  })
  appInsights.loadAppInsights()

  Vue.config.errorHandler = err => {
    appInsights.trackException({ exception: err })
    console.error(err)
  }
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
